import { useStaffSession } from '@/hooks/useStaffSession'
import { CUSTOMER_FILL_APPLICATION_TAB, customerTabHref } from '@/lib/customerTabs'
import { CONFIRM_INFO_PATH } from '@/models/confirmInfo'
import { ChatLink } from './ChatLink'

/** The chat's review step: the customer's confirm page, or for staff reading their chat, the Intake tab. */
export function ChatConfirmInfoLink({ orgId, label }: { orgId?: string; label: string }) {
  const staffSession = useStaffSession()
  if (staffSession && orgId) {
    return (
      <ChatLink
        href={customerTabHref(orgId, CUSTOMER_FILL_APPLICATION_TAB)}
        label="Review it on the Intake tab"
      />
    )
  }
  return <ChatLink href={CONFIRM_INFO_PATH} label={label} />
}
